'use strict';

// Utility includes
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('./analytics/viewItemList'));
});
